import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { siteConfig } from '../../config/siteConfig';
import styled from 'styled-components';
import { disableAnalytics, enableAnalytics } from '../../config/posthog';
import { COOKIE_CONSENT_KEY, getCookie } from '../../helpers/cookies';
import Button, { ButtonType } from '../Button/Button';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const BannerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  background: #fff;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 2px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  font-size: 14px;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: left;

  @media screen and (max-width: 768px) {
    width: calc(100vw - 6rem);
    height: auto;
    min-height: 200px;
  }
`;

const BannerTitle = styled.h3`
  color: var(--text);
  font-weight: 500;
  font-size: 18px;
  margin: 0;
  text-align: left;
  width: 100%;
`;

const BannerText = styled.div`
  color: var(--text-muted);
  font-weight: 400;
  line-height: 1.4;
  width: 100%;

  a {
    color: var(--active-blue);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
`;

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isExport = location.pathname.includes('export');

  useEffect(() => {
    const consent = getCookie(COOKIE_CONSENT_KEY);
    if (consent !== 'accepted' && consent !== 'rejected') {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    enableAnalytics();
    setIsVisible(false);
  };

  const handleReject = () => {
    disableAnalytics();
    setIsVisible(false);
  };

  if (isExport) {
    return null;
  }

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <Backdrop />
      <BannerContainer>
        <BannerTitle>
          <FormattedMessage id="cookieBanner.title" />
        </BannerTitle>
        <BannerText>
          <FormattedMessage
            id="cookieBanner.text"
            values={{ appName: siteConfig.appName }}
          />
        </BannerText>
        <ButtonContainer>
          <Button type={ButtonType.Primary} onClick={handleAccept} fill>
            <FormattedMessage id="cookieBanner.accept" />
          </Button>
          <Button type={ButtonType.Tertiary} onClick={handleReject} fill>
            <FormattedMessage id="cookieBanner.reject" />
          </Button>
        </ButtonContainer>
        <BannerText>
          <FormattedMessage id="cookieBanner.readMore" />{' '}
          <a href={siteConfig.termsUrl} target="_blank">
            <FormattedMessage id="cookieBanner.termsLink" />
          </a>
        </BannerText>
      </BannerContainer>
    </>
  );
};
